export const DEFAULT_MENU_COLUMN_LIMIT = 11;

export function getMenuColumnLimit(settings) {
    const limit = Number(settings && settings.univ && settings.univ.menuColumnLimit);
    return limit > 0 ? limit : DEFAULT_MENU_COLUMN_LIMIT;
}

export function computeMenuColumns(isSub, limit) {
    const groups = [];
    for (const sub of isSub) {
        if (sub && groups.length) {
            groups[groups.length - 1]++;
        } else {
            groups.push(1);
        }
    }

    const columns = [];
    let sum = 0;
    for (const size of groups) {
        if (sum + size <= limit || sum === 0) {
            sum += size;
        } else {
            columns.push(sum);
            sum = size;
        }
    }
    if (sum > 0) {
        columns.push(sum);
    }
    return columns;
}

export const EVENT_MONTHS = {
    lv: ['JAN', 'FEB', 'MAR', 'APR', 'MAI', 'JŪN', 'JŪL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'],
    en: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'],
    lt: ['SAU', 'VAS', 'KOV', 'BAL', 'GEG', 'BIR', 'LIE', 'RGP', 'RGS', 'SPA', 'LAP', 'GRU'],
};

export function eventMonthLabel(date, language) {
    const months = EVENT_MONTHS[language] || EVENT_MONTHS.lv;
    return months[date.getMonth()];
}
